import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { BrdsqlService } from '../../../services/brdsql.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit ,OnDestroy {

  requestdata?: any = [];
  @ViewChild('tb_data') tb_data!: ElementRef;

  constructor(private brdsqlservice: BrdsqlService) { }

  ngOnInit(): void {
    this.requestData();
  }

  // โหลดข้อมูลการขอแก้ไขแปลงของโซน
  dataApi?: any = [];
  requestData() {
    this.dataApi = [];
    this.brdsqlservice.listRequestEditPlotManager()
      .subscribe({
        next: (data: any) => {
          this.dataApi = data.recordset;
          setTimeout(() => {
            $(this.tb_data.nativeElement).DataTable();
          }, 0);
        }, error: (e) => console.error(e)
      })
  }

  refreshList(): void {
    this.requestData();
    // this.currentTutorial = {};
    // this.currentIndex = -1;
  }  

  ngOnDestroy(): void {
    if (this.dataApi) {
      this.dataApi.unsubscribe();
    }
  }

}
